import { isInsertLinkPendingOrFailed } from './isInsertLinkPendingOrFailed';

export function getAtLeastOneInsertLinkPendingOrFailed(allInsertLinks: string[]): boolean {
    const result = allInsertLinks.some(linkId => isInsertLinkPendingOrFailed(linkId));
    return result;
}
